import axiosInstance from "./axiosInstance";

// load last saved code for a question
export const loadSavedCode = async (labInternalId, questionId) => {
  const res = await axiosInstance.get(`/code/${labInternalId}/${questionId}`);
  return res.data; // { code: string }
};

// save code draft
export const saveCode = async (labInternalId, questionId, code) => {
  const res = await axiosInstance.post(`/code/${labInternalId}/${questionId}`, { code });
  return res.data;
};
